<template>
    <div class="pro-single">
        <Breadcrumb></Breadcrumb>
        <!-- 产品定制_我的设计 -->
        <el-container style="background: white;">
            <el-header>
                商品详情
                <div class="header-but">
                    <el-button size="small" type="info" plain @click="showDesign">返回</el-button>
                    <el-button size="small" type="primary" style="margin-left: 10px;" @click="hitAddCart()"> 加入购物车 </el-button>
                </div>
            </el-header>
            <div class="main-text">
                <el-row>
                    <el-col :span="1.5">生产时长：</el-col>
                    <el-col :span="10">{{pageData.cycle}}天</el-col>
                </el-row>
                <el-row>
                    <el-col :span="1.5">产品名称：</el-col>
                    <el-col :span="10">{{pageData.name}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="1.5">商品视图：</el-col>
                </el-row>
                <el-row class="pic-list">
                    <ul style="list-style: none;">
                        <li style="float: left;margin: 0 8px;" v-for="pic in pagePic">
                            <el-popover placement="top" width="200" trigger="hover">
                                <img class="img-normal" :src="pic.picUrl" style="width: 200px;height: 200px;">
                                <img slot="reference" class="img-normal" :src="pic.picUrl" style="width: 90px;height: 90px;">
                            </el-popover>
                        </li>
                    </ul>
                </el-row>
            </div>
        </el-container>
        <div class="s">
            <div class="top-tabs sticky">
                <div class="tabs-list">
                    <div class="tab-name text-noSelect isSelect" @click="tabClick($event,'01')">产品详情</div>
                    <el-divider direction="vertical"></el-divider>
                    <div class="tab-name text-noSelect" @click="tabClick($event,'02')">产品尺码</div>
                    <el-divider direction="vertical"></el-divider>
                    <div class="tab-name text-noSelect" @click="tabClick($event,'03')">包装规格</div>
                </div>
            </div>
            <div class="tab-content">
                <div class="plan-div">
                    <div id="p_d" class="plan-title text-noSelect">产品详情</div>
                    <div class="plan-content">
                        <el-row class="sku-name">
                            <el-col :span="8">
                                <span class="span_1">商品名称 :</span><span>{{pageData.name}}</span>
                            </el-col>
                            <el-col :span="8">
                                <span class="span_1">原始名称 :</span><span>{{pageData.basicName}}</span>
                            </el-col>
                            <el-col :span="8">
                                <span class="span_1">产品编号 :</span><span>{{pageData.code}}</span>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="plan-div">
                    <div id="p_s" class="plan-title text-noSelect">产品尺码</div>
                    <div v-if="pageData.sizeImgUrl != null" style="text-align: center;">
                        <img class="img-normal" :src="pageData.sizeImgUrl">
                    </div>
                    <div v-else>
                        <el-table :data="tableData" class="size-tab">
                            <el-table-column label="尺寸" align="center" prop="size"></el-table-column>
                            <el-table-column label="建议身高" align="center" prop="stature"></el-table-column>
                            <el-table-column label="肩宽" align="center" prop="shoulder"></el-table-column>
                            <el-table-column label="1/2胸围(cm)" align="center" prop="bust"></el-table-column>
                            <el-table-column label="美国码(code)" align="center" prop="us"></el-table-column>
                            <el-table-column label="亚洲码(code)" align="center" prop="ay"></el-table-column>
                            <el-table-column label="欧洲码(code)" align="center" prop="te"></el-table-column>
                            <el-table-column label="衣长(cm)" align="center" prop="length"></el-table-column>
                            <el-table-column label="1/2腰围(cm)" align="center" prop="waist"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="plan-div">
                    <div id="p_r" class="plan-title text-noSelect">包装规格</div>
                    <div>
                        <el-table :data="firstSku" border class="size-tab">
                            <!--<template slot-scope="scope">-->
                                <el-table-column label="包装尺寸(cm) (长*宽*高)" align="center" prop=""></el-table-column>
                                <el-table-column label="含包装重量" align="center" prop="weight"></el-table-column>
                                <el-table-column label="包装体积(cm³)" align="center" prop=""></el-table-column>
                            <!--</template>-->
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"   title="加入购物车" :visible.sync="dialogTableVisible">
            <div class="cartType" v-for="item in cartData">
                <el-row>
                    <el-col :span="6">{{item.size}}</el-col>
                    <el-col :span="6">￥{{item.price}}</el-col>
                    <el-col :span="12">
                        <el-input-number size="mini" :precision="0" :min="0" :step="1" step-strictly v-model.number="item.count" @change="getTotalCount"></el-input-number>
                    </el-col>
                </el-row>
            </div>
            <el-row style="padding: 2% 5%;padding-right: 8%;">
                <el-col :span="12" style="float: left">
                    <span>总件数: {{totalCount}}</span><br>
                    <span>均价: {{totalNum}}/件</span>
                </el-col>
                <el-col :span="12" style="float: right;text-align: right;color: red;font-size: 25px;">￥{{totalPrice}}</el-col>
            </el-row>
            <el-button class="cart-but" @click="confirmAddCart">确认</el-button>
        </el-dialog>

    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getDetails} from '@/api/customProduct/design'
    // import {mapGetters} from 'vuex'
    import {getDesignSku} from '@/api/customProduct/designSku'
    import {addToShoppingCart} from'@/api/customProduct/custom'

    export default {
        name: "product",
        components:{Breadcrumb},
        data(){
            return{
                closeDelay:0,
                pageData: [],
                pagePic:[],
                tableData: [
                    {"size": "S", "stature": "155-160", "shoulder": "39.5cm", "bust": "45cm", "us": "S", "ay": "160/80A", "te": "S", "length": "61cm", "waist": "45cm"},
                    {"size": "M", "stature": "160-165", "shoulder": "41cm", "bust": "49cm", "us": "M", "ay": "165/84A", "te": "M", "length": "63cm", "waist": "49cm"},
                    {"size": "L", "stature": "165-170", "shoulder": "42.5cm", "bust": "53cm", "us": "L", "ay": "170/88A", "te": "L", "length": "65cm", "waist": "53cm"},
                    {"size": "XL", "stature": "170-175", "shoulder": "44cm", "bust": "57cm", "us": "XL", "ay": "175/92A", "te": "XL", "length": "67cm", "waist": "57cm"},
                    {"size": "XXL", "stature": "175-180", "shoulder": "45.5cm", "bust": "61cm", "us": "2XL", "ay": "180/96A", "te": "2XL", "length": "69cm", "waist": "61cm"}
                ],
                tableData1: [
                    {"specification": "未知", "weight": "0.48", "volume":"未知"}
                ],
                firstSku:{},
                dialogTableVisible: false,
                cartData: [],
                totalCount: 0,
                totalNum: 0.00,
                totalPrice: 0.00,
                isCart:true,

            }
        },
        methods:{
            tabClick(e,val){
                let _dom = document.querySelector('.tabs-list .isSelect');
                if (_dom) {
                    _dom.classList.toggle('isSelect');
                }
                e.target.classList.toggle('isSelect');
                let id = undefined;
                if(val == '01'){
                    id = 'p_d';
                }else if(val == '02'){
                    id = 'p_s';
                }else if(val == '03'){
                    id = 'p_r';
                }
                document.getElementById(id).scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'})
            },

            /*返回__跳回我的设计(即上一页面)*/
            showDesign(){
                this.$router.push({path:'/carry/proCustom/design'})
            },

            loadData() {
                let query = this.$route.query;
                this.pageData = query;
                let particulats = sessionStorage.getItem("particulats");
                let temp = null;
                if (particulats == null) {
                    sessionStorage.setItem("particulats", JSON.stringify({"firstPic": query.firstPic, "firstSku": query.firstSku}));
                    temp = query;
                } else {
                    temp = JSON.parse(particulats);
                }
                this.pagePic = temp.firstPic;
                this.firstSku = temp.firstSku;
            },

            /*点击加入购物车*/
            hitAddCart() {
                if (this.isCart) {
                    this.getSkuList(this.pageData.designId); //获取skuList
                    this.isCart = false;
                }
                this.dialogTableVisible = true;
            },

            /*通过商品id获取skuList*/
            getSkuList(designId) {
                getDesignSku(designId).then((re) => {
                    this.cartData = re.data;
                })
            },

            /*购物车弹框的计数*/
            getTotalCount(val1,obj){
                let count = 0; let price = 0.00;
                this.cartData.forEach(item =>{
                    if(item.count != 0){
                        count += item.count;
                        price += item.price * item.count;
                    }
                });
                this.totalCount = count;
                if (count == 0) {
                    this.totalNum = 0.00;
                } else {
                    this.totalNum = (price/count).toFixed(2);
                }
                this.totalPrice = price.toFixed(2);
            },

            /*确认加入购物车*/
            confirmAddCart() {
                if (this.totalCount == 0) {
                    this.$message({ message: '请至少添加一件!', type: 'warning', duration: 700});
                } else {
                    this.dialogTableVisible = false;
                    let i = 0;
                    this.cartData.forEach(item =>{
                        i++;
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params).then(res =>{
                            if(res.code==200 && this.cartData.length==i){
                                this.$message({message: "加入购物车成功", type:"success", duration: 700});
                            }
                        }).catch(err =>{});
                    });
                    this.isCart=true;
                    this.totalCount=0;
                    this.totalNum=0.00;
                    this.totalPrice=0.00;
                }
            },

        },

        created() {
            //打开页面立刻执行的方法
            var that = this;
            that.loadData();

        },

        // computed:{
        //     ...mapGetters(['nginx']),
        // },

        beforeDestroy(){
            // 离开页面后销毁
            sessionStorage.removeItem("particulats");
        },
        
    }
</script>

<style scoped>
    .el-container {
        margin-top: 2%;
        border: 1px solid #d7d7d7;
    }

    .el-header {
        color: #333;
        line-height: 60px;
        font-weight: bold;
        margin-top: 1%;
        width: 94%;
        margin-left: 3%;
        font-size: 20px;
    }

    .el-main {
        width: 94%;
        color: #333;
        line-height: 160px;
        margin-left: 3%;
    }

    .el-header .header-but {
        float: right;
    }
    .el-container .main-text {
        margin: 1% 4.3% 2% 4.3%;
        line-height: 32px;
        font-size: 15px;
    }

    .el-dialog__wrapper >>> .el-dialog {
        width: 20%;
    }

    .cartType .el-row {
        padding: 3% 0px;
        border-bottom: 1px dashed #88888847;
        text-align: center;
    }

    .cart-but {
        background: #ff5561;
        width: 95%;
        height: 36px;
        font-size: 18px;
        color: white;
        margin-bottom: 2%;
        margin-left: 2%;
        line-height: 0;
    }


</style>
